class Login {
    constructor() {
        this.nomeAcesso = null
        this.senhaAcesso = null
    }
}
export default Login;